import React, { useState, useEffect } from "react";
import { theme } from "../../../index";
import { Shimmer } from "react-shimmer";
import ClipLoader from "react-spinners/ClipLoader";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { dataLimit } from "../../..";
import {
  addSubCategory,
  deleteSubCategory,
  fetchSubCategory,
  editSubCategory,
} from "../../../api/testSeries/subcategory";
import SubCategoryRow from "./SubCategoryRow";
import { useParams, useHistory } from "react-router-dom";
const SubCategory = (props) => {
  const params = useParams();
  const [offset, setOffset] = useState(0);
  const [showShimmer, setShowShimmer] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [loadingAddSubCategory, setLoadingAddSubCategory] = useState(false);
  const [isLast, setIsLast] = useState(false);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [addSubCategoryData, setAddSubCategoryData] = useState({});
  const [mode, setMode] = useState();
  const { categoryId } = useParams();
  const [editIndex, setEditIndex] = useState();
  const history = useHistory();


  const addSubCategoryBtnHandler = async () => {
    setLoadingAddSubCategory(true);
    const response = await addSubCategory({ ...addSubCategoryData, testSeriesExamTestType: { id: categoryId } });
    if (response.status) {
      setSubCategoryData([...subCategoryData, { ...addSubCategoryData, id: response.data.id, testSeriesExamTestType: { id: categoryId } }])
      setAddSubCategoryData({});
      setLoadingAddSubCategory(false);
    }
    setIsAddModalVisible(false);
  };

  const editSubCategoryBtnHandler = async () => {
    setLoadingAddSubCategory(true);
    addSubCategoryData["testSeriesExamTestType"] = { id: categoryId };
    const response = await editSubCategory(addSubCategoryData);
    if (response.status) {
      addSubCategoryData["id"] = response.data.id;
      const arr = [...subCategoryData];
      arr[editIndex] = addSubCategoryData;
      setSubCategoryData(arr);
      setAddSubCategoryData({});
      setLoadingAddSubCategory(false);
    }
    setIsAddModalVisible(false);
  };

  const getTestSeriesCategory = async () => {
    const response = await fetchSubCategory(categoryId, offset, dataLimit);
    if (response.status) {
      setSubCategoryData(response.data?.data?.rows);

      setIsLast(response.data.last);
    } else {
      console.log("Error in fetching");
    }
    setShowLoader(false);
  };
  useEffect(() => {
    setShowLoader(true);
    getTestSeriesCategory();
  }, [offset]);

  const handleInputChange = (e) => {
    const obj = { ...addSubCategoryData };
    obj[e.target.name] = e.target.value;
    setAddSubCategoryData(obj);
  };

  const deleteBtnHandler = async (id, index) => {
    if (window.confirm("Are you sure you want to delete this Test Series")) {
      const response = await deleteSubCategory(id);
      console.log(response);
      if (response.status) {
        const arr = [...subCategoryData];
        arr.splice(index, 1);
        setSubCategoryData(arr);
      } else {
        console.log("Error in fetching");
      }
    }
  };

  console.log(params?.categoryId);
  return (
    <div>
      <div class="page-breadcrumb  d-md-flex align-items-center mb-3">
        <div class="breadcrumb-title pr-3">Test Types</div>
        <div class="pl-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
              <li class="breadcrumb-item">
                <a href="javascript:;">
                  <i class="bx bx-home-alt"></i>
                </a>
              </li>
            </ol>
          </nav>
        </div>
        <div class="ml-auto">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-danger"
              style={{ marginRight: 5 }}
              onClick={() => {
                setIsAddModalVisible(true);
                setAddSubCategoryData({});
                setMode("add");
              }}
            >
              Add
            </button>
            <button
              type="button"
              class="btn btn-dark"
              onClick={() => history.goBack()}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>

      {showLoader ? (
        <Shimmer width={"100%"} height={40} />
      ) : (
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table
                class="table table-striped table-bordered mb-0"
                id="table1"
              >
                <thead class="thead-dark">
                  <tr>
                    <th align="center">#</th>
                    <th align="center">Title</th>
                    <th align="center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showShimmer ? (
                    <td colspan="9">
                      <Shimmer width={"100%"} height={40} />
                    </td>
                  ) : (
                    subCategoryData &&
                    subCategoryData.map((row, i) => (
                      <SubCategoryRow
                        catName={params?.categoryName}
                        catid={params?.categoryId}
                        setIsAddModalVisible={setIsAddModalVisible}
                        row={row}
                        index={i}
                        deleteBtnHandler={deleteBtnHandler}
                        setMode={setMode}
                        setAddSubCategoryData={setAddSubCategoryData}
                        setEditIndex={setEditIndex}
                      />
                    ))
                  )}
                </tbody>
              </table>
              <br />
              <div>
                {offset == 0 ? null : !showLoader ? (
                  <button
                    aria-label="delete"
                    onClick={() => setOffset(offset - 1)}
                    className="btn btn-dark mr-1"
                  >
                    Previous
                  </button>
                ) : null}

                {isLast ? null : !showLoader ? (
                  <button
                    aria-label="delete"
                    onClick={() => setOffset(offset + 1)}
                    className="btn btn-primary mr-1"
                  >
                    Next
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        size="lg"
        show={isAddModalVisible}
        onHide={() => setIsAddModalVisible(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ zIndex: 10000 }}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {mode == "add" ? "Add Test Type" : "Edit Test Type"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  onChange={handleInputChange}
                  value={addSubCategoryData["title"]}
                  required
                />
              </Form.Group>
            </Row>
            {/* <Row>
                            <Form.Group
                                as={Col}
                                md="12"
                                className="position-relative"
                            >
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    type="textarea"
                                    name="description"
                                    onChange={handleInputChange}
                                    value={addSubCategoryData['description']}
                                />
                            </Form.Group>
                        </Row> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setIsAddModalVisible(false)}
            style={{
              backgroundColor: theme.greyColor,
              color: theme.primaryColor,
            }}
          >
            Close
          </Button>
          <Button
            type="submit"
            variant="primary"
            style={{
              backgroundColor: theme.darkPurpleColor,
              marginLeft: 10,
              color: theme.primaryColor,
            }}
            onClick={() =>
              window.confirm(
                mode == "add"
                  ? "Are You Sure You Want To Add?"
                  : "Are You Sure You Want To Edit?"
              )
                ? mode == "add"
                  ? addSubCategoryBtnHandler()
                  : editSubCategoryBtnHandler()
                : console.log("no")
            }
          >
            {loadingAddSubCategory ? (
              <ClipLoader
                color={theme.primaryColor}
                loading={loadingAddSubCategory}
              />
            ) : mode == "add" ? (
              "Add"
            ) : (
              "Edit"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SubCategory;
